import { createStore, applyMiddleware, compose } from 'redux';
//import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import rootReducer from './reducers';

//@ts-ignore
const composeEnhancers =  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; 
//const composeEnhancers = composeWithDevTools({trace: true}) || window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; 
    
export const getStore = (initialStore) => {
    return createStore(
        rootReducer,
        initialStore,
        composeEnhancers(applyMiddleware(thunk))
    );
}

